module.exports = __webpack_public_path__ + "img/img_sfzsb.fa57116e.png";